import { 
  collection, addDoc, updateDoc, doc, getDocs, query, where, Timestamp 
} from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION_NAME = 'verificaciones';

export const PLANTILLA_VERIFICACION = {
  runt: {
    verificada: false,
    fecha: null,
    resultado: null,
    observaciones: ''
  },
  simit: {
    verificada: false,
    fecha: null,
    multas: false,
    observaciones: ''
  },
  embargos: {
    verificada: false,
    fecha: null,
    tieneEmbargos: false,
    observaciones: ''
  },
  improntas: {
    verificada: false,
    fecha: null,
    coinciden: false,
    observaciones: ''
  },
  soat: {
    verificada: false,
    fecha: null,
    vigente: false,
    fechaVencimiento: null,
    observaciones: ''
  },
  tecnomecanica: {
    verificada: false,
    fecha: null,
    vigente: false,
    fechaVencimiento: null,
    observaciones: ''
  }
};

export const crearVerificacion = async (casoId) => {
  try {
    const data = {
      casoId,
      ...PLANTILLA_VERIFICACION,
      fechaCreacion: Timestamp.now(),
      fechaActualizacion: Timestamp.now(),
      activo: true
    };
    const docRef = await addDoc(collection(db, COLLECTION_NAME), data);
    return { id: docRef.id, ...data };
  } catch (error) {
    console.error("Error al crear verificación:", error);
    throw error;
  }
};

export const obtenerVerificacionPorCaso = async (casoId) => {
  try {
    const q = query(
      collection(db, COLLECTION_NAME),
      where("casoId", "==", casoId),
      where("activo", "==", true)
    );
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const doc = querySnapshot.docs[0];
      return {
        id: doc.id,
        ...doc.data(),
        fechaCreacion: doc.data().fechaCreacion?.toDate()
      };
    }
    return null;
  } catch (error) {
    console.error("Error al obtener verificación:", error);
    throw error;
  }
};


export const actualizarItemVerificacion = async (verificacionId, item, datos) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, verificacionId);
    const updateData = {
      [`${item}.verificada`]: datos.verificada || false,
      [`${item}.fecha`]: datos.fecha ? Timestamp.fromDate(datos.fecha) : null,
      [`${item}.observaciones`]: datos.observaciones || '',
      fechaActualizacion: Timestamp.now()
    };
    
    if (datos.resultado !== undefined) updateData[`${item}.resultado`] = datos.resultado;
    if (datos.multas !== undefined) updateData[`${item}.multas`] = datos.multas;
    if (datos.tieneEmbargos !== undefined) updateData[`${item}.tieneEmbargos`] = datos.tieneEmbargos;
    if (datos.coinciden !== undefined) updateData[`${item}.coinciden`] = datos.coinciden;
    if (datos.vigente !== undefined) updateData[`${item}.vigente`] = datos.vigente;
    if (datos.fechaVencimiento !== undefined) {
      updateData[`${item}.fechaVencimiento`] = datos.fechaVencimiento ? Timestamp.fromDate(datos.fechaVencimiento) : null;
    }
    
    await updateDoc(docRef, updateData);
    return true;
  } catch (error) {
    console.error("Error al actualizar verificación:", error);
    throw error;
  }
};